var api = require("!../../../node_modules/.pnpm/style-loader@2.0.0_webpack@5.106.2_@swc+core@1.15.30_@swc+helpers@0.5.21__esbuild@0.27.7_/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js");
            var content = require("!!../../../node_modules/.pnpm/css-loader@5.2.7_webpack@5.106.2_@swc+core@1.15.30_@swc+helpers@0.5.21__esbuild@0.27.7_/node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!../../../node_modules/.pnpm/postcss-loader@7.3.4_@typescript+typescript6@6.0.2_postcss@8.5.19_webpack@5.106.2_@swc+_c5e63af80479771cc923974b2545fb29/node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[5].use[0]!./clay.entrypoint.css");

            content = content.__esModule ? content.default : content;

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



module.exports = content.locals || {};